import * as React from 'react';
import { useState } from 'react';
import * as Yup from 'yup';
import SaleHeader from './SaleHeader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import SaleFormEmailOrSms, { sendToName } from './SaleFormEmailOrSms';
import FormikForm from '~/lib/forms/FormikForm';
import Button from '~/common/elements/mobile/Button';
import { buttonColor, buttonSize, buttonStyle, icons } from '~/common/elements/mobile/consts';
import { emailRegExp, phoneRegExp } from '~/apps/shared/consts';
import { getSaleNumber } from "~/apps/pos/helpers";

const saleSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  email: Yup.string().matches(emailRegExp, 'Email is not valid'),
});

type Props = {
  initialValues: any,
  result: any,
  onSubmit: any,
  handleActions: any,
  onView: (saleId) => void;
  features: string[];
}

const SaleStepResult = (props: Props) => {
  const { initialValues, handleActions, onView, features } = props;
  const [sendTo, setSendTo] = useState(null);
  const [errorInfo, setInfoMessage] = useState({
    isError: false,
    message: '',
  });

  const handleSaleView = (e) => {
    e.preventDefault();
    onView(props.result.id);
  };

  const cbResponse = (result) => {
    if (result.isError) {
      setInfoMessage({
        isError: true,
        message: result.message,
      });
    } else {
      setInfoMessage({
        isError: false,
        message: result.message,
      });
    }
  };

  const clearMessage = () => {
    setInfoMessage({
      isError: false,
      message: '',
    });
  };

  const handleSends = (action, options = {}) => {
    switch (action) {
      case 'receipt-text':
        clearMessage();
        setSendTo(sendToName.SMS);
        break;

      case 'receipt-email':
        clearMessage();
        setSendTo(sendToName.MAIL);
        break;

      case 'send-to-sms':
        handleActions('request-sms', { ...options, cb: cbResponse });
        setSendTo(null);
        break;

      case 'send-to-email':
        handleActions('request-email', { ...options, cb: cbResponse });
        setSendTo(null);
        break;

      case 'cancel-send':
        setSendTo(null);
        break;

      default:
        break;
    }
  };

  return (
    <FormikForm
      initialValues={initialValues}
      validationSchema={saleSchema}
      render={(propsForm) => {
        const { errors, values: { phone, email } } = propsForm;
        const isErrPhone = errors.hasOwnProperty('phone') || !phone;
        const isErrEmail = errors.hasOwnProperty('email') || !email;


        return (
          <PageMobileWrapper>
            <SaleHeader
              onBack={handleActions}
              onHelp={handleActions}
              title="Result"
            />

            <BodyWrapper>
              <div className="m__body__i lg"><span className="i i-truck" /></div>
              <div className="m__body__titl--lg">Good to go!</div>
              <p className="m__body__info">A {`$${props.result.price}`} sale has been processed.<br />
                <a onClick={handleSaleView} className="btn btn--sm btn--secn">See details</a>
              </p>
              <p className="m__body__info">Confirmation Number <br />
                <span className="m__body__info__note typ--b">{getSaleNumber(props.result, features)}</span>
              </p>

            </BodyWrapper>

            <FooterWrapper>
              {/* TODO: Return api message for success state for consistency */}
              {errorInfo.message ?
                <p className={errorInfo.isError ? 'btn--tag--ti btn--warn' : 'btn--tag--ti btn--prim' }>{errorInfo.message}</p> : ''
              }
              <SaleFormEmailOrSms
                sendTo={sendTo}
                handleSends={handleSends}
                options={{ saleId: props.result.id, phone, email }}
                errorInfo={errorInfo}
                isErrPhone={isErrPhone}
                isErrEmail={isErrEmail}
              />
              {
                !sendTo &&
                <div className="m__foot__btns__dbl --gtg">
                  <Button
                    title="Text Receipt"
                    actionKey="receipt-text"
                    buttonStyle={buttonStyle.OUTL}
                    buttonSize={buttonSize.LG}
                    iconType={icons.MSG}
                    onClick={(actionKey) => handleSends(actionKey)}
                  />
                  < Button
                    title="Email Receipt"
                    actionKey="receipt-email"
                    buttonStyle={buttonStyle.OUTL}
                    buttonSize={buttonSize.LG}
                    iconType={icons.MAIL}
                    onClick={(actionKey) => handleSends(actionKey)}
                  />
                </div>
              }
              {
                !sendTo &&
                <Button
                  title="Print receipt"
                  actionKey="receipt-print"
                  buttonStyle={buttonStyle.OUTL}
                  buttonSize={buttonSize.LG}
                  onClick={(actionKey) => handleActions(actionKey)}
                />
              }
              <Button
                title="done"
                actionKey="result-done"
                buttonStyle={buttonStyle.OUTL_LITE}
                buttonSize={buttonSize.LG}
                buttonColor={buttonColor.PRIM}
                onClick={(actionKey) => handleActions(actionKey)}
              />
            </FooterWrapper>
          </PageMobileWrapper>
        );
      }}
    />
  );
};

export default SaleStepResult;
